var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h2',[_vm._v("¡Lo sentimos!")]),_c('h3',[_vm._v("No encontramos la página solicitada")]),_c('v-btn',{staticClass:"accent mr-1",attrs:{"to":"/"}},[_vm._v("Ir a Home Page")]),_c('v-btn',{staticClass:"accent ml-1",attrs:{"outlined":"","to":"/login"}},[_vm._v("Iniciar Sesión")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }